import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserState } from '@store/states/user.state';
import { Help } from '@shared/constants/help';
import { portugueseProcedureTypesActions, spanishProcedureTypesActions } from '@pages/my-procedures/my-procedures';
import { PortugalHelp } from '@shared/constants/portugal-help';

const userSelector = createFeatureSelector<UserState>('user');

export const userSelectors = {
  authUser: createSelector(userSelector, (state) => state.user),
  authUserError: createSelector(userSelector, (state) => state.error),
  isSuperUser: createSelector(userSelector, (state) => state.user?.superUser ?? false),
  helpEmail: createSelector(userSelector, (state) => {
    if (state.country === 'PT') {
      return PortugalHelp.EMAIL;
    }
    return state.user?.type === 'PYMES' ? Help.EMAILPYMES : Help.EMAILGGCC;
  }),
  dataProtection: createSelector(userSelector, (state) => state.user?.dataProtection),
  country: createSelector(userSelector, (state) => state.country),
  multipleCountries: createSelector(userSelector, (state) => state.multipleCountries),
  waitingForCountry: createSelector(userSelector, (state) => state.waitingForCountry),
  waitingForDataProtection: createSelector(userSelector, (state) => state.waitingForDataProtection),
  impersonationToken: createSelector(userSelector, (state) => state.impersonationToken),
  webIsReady: createSelector(userSelector, (state) => !state.waitingForDataProtection && !state.waitingForCountry),
  proceduresCollection: createSelector(userSelector, (state) =>
    state.country === 'ES' ? spanishProcedureTypesActions : portugueseProcedureTypesActions
  ),
  societyLabel: createSelector(userSelector, (state) => (state.country === 'ES' ? 'GENERAL.SOCIETY_CIF' : 'GENERAL.SOCIETY_NIF')),
  installationLabel: createSelector(userSelector, (state) =>
    state.country === 'ES' ? 'GENERAL.INSTALLATION_CUPS' : 'GENERAL.INSTALLATION_CPE'
  ),
};
